import axios from 'axios'
import router from '../router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

let baseURL = ''
if(process.env.NODE_ENV === 'development'){
  baseURL = 'http://192.168.28.75:6066/'
}
// if(router.currentRoute.value.path=='/'){
//   baseURL = 'http://gitea.smtjhd.com/'
// }
console.log(process.env.NODE_ENV,'开发环境');
const instance = axios.create({
  baseURL,
  timeout: 120000 // 请求超时时间
})
//拦截器
// 请求拦截器
instance.interceptors.request.use(config=> {
    // NProgress.start()
    // 在请求前可以修改配置信息---添加请求头--token
    // if(router.currentRoute.value.path!='/login'){
    //   config.headers.Authorization = 'Bearer '+sessionStorage.getItem('token')
    // }
    return config;
  },function (error){
    // Do something with request error
    return Promise.reject(error);
}); 
  
// 响应拦截器
instance.interceptors.response.use(res=> {
	  //对响应数据做点什么
    // 相应后的拦截处理
    // NProgress.done()
    return res;
  },function (error){
    // NProgress.done()
    // Do something with response error
    return Promise.reject(error);
});

export default instance